import $ from 'jquery';

class Ticker {
    constructor() {
        this.listeners();
    }

    listeners() {
        $('.ticker-button').on('click', function () {
            $(this)
                .toggleClass('ticker-button--pause')
                .toggleClass('ticker-button--play');
            $(this).children('.ticker-button-img').toggleClass('hide');
            $('.ticker').toggleClass('pause');
        });
    }
}

export default Ticker;
